export const LOAN_STATUS_OPTIONS = ['confirmed', 'invested', 'active', 'overdue', 'paid', 'returned', 'cancelled'];
